import type { Mission } from '../missions.ts'

export const ftc: Mission = {
  id: "ftc",
  name: "Federal Trade Commission",
  short: "FTC",
  call: "Competition",
  kind: "independent",
  url: "https://www.ftc.gov/",
  established: 1914,
  palette: {
    primary: "#1d3557",
    secondary: "#065cb4",
    accent: "#77b2bf",
  },
  colorSource: {
    kind: "site",
    url: "https://www.ftc.gov/",
  },
  motif: "shield",
  mission: {
    text: "The FTC’s mission is to vigorously enforce the law to protect Americans from anticompetitive, unfair, and deceptive business practices, without unduly burdening legitimate business activity.",
    url: "https://www.ftc.gov/about-ftc",
  },
  fact: {
    text: "The FTC was created on September 26, 1914, when President Woodrow Wilson signed the Federal Trade Commission Act into law.",
    url: "https://www.ftc.gov/about-ftc/history",
  },
  seal: {
    file: "public/seals/ftc.png",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Federal_Trade_Commission.svg",
  },
  identifier: {
    about: "https://www.ftc.gov/about-ftc",
    accessibility: "https://www.ftc.gov/policy-notices/accessibility",
    foia: "https://www.ftc.gov/foia",
    noFear: "https://www.ftc.gov/policy-notices/no-fear-act",
    oig: "https://oig.ftc.gov/",
    performance: "https://www.ftc.gov/about-ftc/budget-strategy",
    privacy: "https://www.ftc.gov/policy-notices/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/ftc-apex-statue.jpg",
        small: "/media/ftc-apex-statue-sm.jpg",
        alt: "The Man Controlling Trade sculpture beside the columned, curved corner of the Federal Trade Commission building",
        title: "Washington, D.C. A statue in front of the Federal Trade Commission building",
        creator: "Esther Bubley, U.S. Office of War Information",
        source: "https://www.loc.gov/pictures/item/2017863894/",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/ftc-man-controlling-trade.jpg",
        small: "/media/ftc-man-controlling-trade-sm.jpg",
        alt: "Limestone sculpture of a muscular man restraining a rearing horse against a pale sky",
        title: "Washington, D.C. A statue in front of the Federal Trade Commission building",
        creator: "Esther Bubley, U.S. Office of War Information",
        source: "https://www.loc.gov/pictures/item/2017863901/",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
